'use strict';

var _ = require('lodash');
var urlJoin = require('url-join');
var sendGet = require('./send-action').get;
var userEndpointMixin = require('./user-endpoint-mixin');
var xhrHelpers = require('xhrhelpers');

function Features(options) {
  options = options || {};
  this._baseUrl = options.baseUrl;
}

Features.prototype.get = function(feature) {
  feature = feature || '';
  var uri = urlJoin(this._baseUrl, this._usersUrl, 'features', feature, '/');
  return sendGet(uri);
};

Features.prototype.getComputed = function() {
  return this.get()
    .then(xhrHelpers.twoHundredsOrThrow)
    .then(xhrHelpers.responseObject)
    .then((features) => _.forEach(features, this.assignActive));
};

Features.prototype.assignActive = function(properties, feature) {
  if (properties.expires) {
    var expireDate = new Date(properties.expires);
    var today = new Date();
    properties.isActive = expireDate > today;
  }
};

_.assignIn(Features.prototype, userEndpointMixin);

module.exports = Features;
